import { createApp } from 'vue'
import { Fancybox } from '@fancyapps/ui'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vueAppInitiator from './modules/vue-app-initiator'
import GosFaqSearch from './vue-components/pages/gos-faq/GosFaqSearch'
import AccordionItem from './vue-components/pages/AccordionItem'
import ShareButton from './vue-components/ui/ShareButton'
import GosFaqForm from './vue-components/pages/gos-faq/GosFaqForm'
import GosFaqNews from './vue-components/pages/gos-faq/GosFaqNews'
import GosFaqSearchNews from './vue-components/pages/gos-faq/GosFaqSearchNews'
import GosFaqOfficialForm from './vue-components/pages/gos-faq/GosFaqOfficialForm'

const vueApps = [
	{
		el: '#gos-faq-form',
		components: {
			GosFaqForm,
		},
	},
	{
		el: '#gos-faq-search',
		components: {
			GosFaqSearch,
		},
	},
	{
		el: '#gos-faq-search-news',
		components: {
			GosFaqSearchNews,
		},
	},
	{
		el: '#gos-faq-news',
		components: {
			GosFaqNews,
		},
	},
]

// родительские компоненты vue.js
const gosFaqParent = document.getElementById('parent') // аккордион

if (gosFaqParent) {
	createApp({
		components: {
			AccordionItem,
			ShareButton,
			GosFaqOfficialForm,
		},
		data() {
			return {
				questionTitle: '',
				questionId: '',
				curActiveRef: null,
				isMobile: window.innerWidth < 768,
				isShowedMore: false,
			}
		},
		methods: {
			setActiveAcc(name, title) {
				Object.keys(this.$refs).forEach(item => {
					this.$refs[item].activated = false
				})

				const sameName = this.curActiveRef === name
				this.curActiveRef = sameName ? null : name

				if (!sameName) {
					this.$refs[name].activated = true
					ym(50230510, 'reachGoal', 'podderzhka-click-info', {
						podderzhka_info_name: title,
					}) // eslint-disable-line
				}
			},
			setQuestionInfo(title, id) {
				window.questionId = id
				window.questionTitle = title
			},
		},
	})
		.use(VueAxios, axios)
		.mount(gosFaqParent)
}

document.addEventListener('DOMContentLoaded', () => {
	vueAppInitiator(vueApps)
	const isMobile = window.innerWidth < 1123

	Fancybox.bind('.js-fancybox', {
		mainClass: 'gos-faq-modal__parent',
		autoFocus: false,
		dragToClose: isMobile,
	})
})
